// Angular
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
// Models
import { DatePipe } from "@angular/common";

import { Attachment } from "./../../models/attachment";
import { Club, Course, Tee } from "./../../models/club";
// External
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";
import { FirebaseApp } from "angularfire2";
import * as moment from "moment";
import * as lodash from "lodash";
import { AmazingTimePickerService } from "amazing-time-picker"; // this line you need

import { ApiService } from "../../services/api";
import { FormsService } from "./../../services/forms";
import { OAuthService } from "app/services/o-auth";

@Component({
  templateUrl: "./app-users.component.html",
})
export class AppUsersComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}
